import { Button, Flex, Text } from '@mantine/core';
import { closeModal, openModal } from '@mantine/modals';
import { AudioPlayer } from '@packages/chat/ui';
import { AUDIO_PLAYER_LABELS } from '@shared/config';
import { useState, type FC } from 'react';

const MODAL_ID = 'listen-voice-message-candidate';

interface CandidateAudioMessageProps {
  audioUrl: string;
  fileName: string;
  onSend?: () => void;
  type: 'listen' | 'upload';
}

const CandidateAudioMessage: FC<CandidateAudioMessageProps> = ({
  audioUrl,
  onSend,
  type,
  fileName,
}) => {
  const [isSent, setIsSent] = useState(false);

  const handleClose = () => {
    closeModal(MODAL_ID);
  };

  // The modal stays clickable during its close transition.
  const handleSend = () => {
    if (isSent) {
      return;
    }

    setIsSent(true);
    onSend?.();
    handleClose();
  };

  return (
    <Flex>
      <Flex direction='column' gap={10} w='100%'>
        <Text size='sm'>{fileName}</Text>
        {audioUrl && (
          <AudioPlayer
            src={audioUrl}
            preload='auto'
            labels={AUDIO_PLAYER_LABELS}
          />
        )}
        <Flex pt={12} gap={8}>
          <Button variant='outline' onClick={handleClose}>
            Отмена
          </Button>
          {type === 'upload' && (
            <Button variant='primary' onClick={handleSend} disabled={isSent}>
              Отправить
            </Button>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

export const useListenVoiceMessage = () => {
  const openCanditateVoiceMessage = ({
    type = 'upload',
    audioUrl,
    fileName,
    onSend,
    onClose,
  }: {
    type?: 'upload' | 'listen';
    audioUrl: string;
    fileName: string;
    onSend?: () => void;
    onClose: () => void;
  }) => {
    const titleModal: { [key in 'upload' | 'listen']: string } = {
      upload: 'Отправить аудиофайл',
      listen: 'Прослушать аудиофайл',
    };
    return openModal({
      modalId: MODAL_ID,
      title: titleModal[type],
      children: (
        <CandidateAudioMessage
          type={type}
          fileName={fileName}
          audioUrl={audioUrl}
          onSend={onSend}
        />
      ),
      onClose: () => {
        onClose();
      },
    });
  };

  return { openCanditateVoiceMessage };
};
